<template>
  <a-form :model="formState">
    <a-form-item label="二次上传覆盖">
      <a-radio-group v-model:value="formData.is_cover_code">
        <a-radio value="0">是</a-radio>
        <a-radio value="1">否</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="生产计划单入库">
      <a-radio-group v-model:value="formData.produce_plan_warehousing">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="0">否</a-radio>
      </a-radio-group>
    </a-form-item>
        <a-form-item label="实体垛标出库">
      <a-radio-group v-model:value="formData.entity_virtual_out">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="0">否</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="开启产品套盒包装">
      <a-radio-group v-model:value="formData.open_code_nested">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="0">否</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="防伪码关联防伪码">
      <a-radio-group v-model:value="formData.enable_stand">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="0">否</a-radio>
      </a-radio-group>
      <div v-if="formData.enable_stand == 1">
        <a-form-item label="扫码关联顺序" class="mb-0">
          <a-radio-group v-model:value="formData.nested_rel_first">
              <a-radio :value="1">先扫产品码</a-radio>
              <a-radio :value="2">先扫包装码</a-radio>
            </a-radio-group>
        </a-form-item>
        <a-form-item label="产品码支持外部码" class="mb-0">
          <a-radio-group v-model:value="formData.nested_outside_code">
              <a-radio :value="1">支持</a-radio>
              <a-radio :value="0">不支持</a-radio>
            </a-radio-group>
        </a-form-item>
        <a-form-item label="追踪查询是否显示产品码信息" class="mb-0">
          <a-radio-group v-model:value="formData.show_code_stand">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="产品码名称" class="mb-0">
          <a-input v-model:value="formData.code_stand_name" style="width: 200px; max-width: 100%" />
        </a-form-item>
      </div>
    </a-form-item>
    <a-form-item label="启用自编隐形码关联">
      <a-radio-group v-model:value="formData.enable_invisible_code">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="0">否</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="单品多级包装关联">
      <a-radio-group v-model:value="formData.open_multi_level_packaging">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="0">否</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item>
      <a-button @click="save" type="primary">保存</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { ref } from "@vue/reactivity";
import {
  getBash,
  bashUpdate,
  getBashpro,
  bashUpdatepro,
} from "@/api/codeManage";
import { inject, onMounted } from "@vue/runtime-core";
import { $iscode } from "../../../utils/app";
export default {
  props: {
    brand_id: String,
  },
  setup(props) {
    const formData = ref({
      is_cover_code: 0,
      produce_plan_warehousing: 0,
      entity_virtual_out:0,
      enable_stand: 0,
      enable_invisible_code: 0,
      nested_rel_first: 1,
      nested_outside_code: 1,
      show_code_stand: 0,
      code_stand_name: "",
      open_multi_level_packaging: 0,
    });
    const router = inject("$router");
    const save = async () => {
      let result = await bashUpdate(props.brand_id, formData.value)
        .then((res) => res.data)
        .catch((error) => error);
      let res = await bashUpdatepro(props.brand_id, formData.value)
        .then((res) => res.data)
        .catch((error) => error);
      if ($iscode(res, true) && $iscode(result, true)) {
        router.go(-1);
      }
    };
    const initData = async () => {
      let result = await getBash(props.brand_id)
        .then((res) => res.data)
        .catch((error) => error);
      formData.value.is_cover_code = result.data.is_cover_code;
      let res = await getBashpro(props.brand_id)
        .then((res) => res.data)
        .catch((error) => error);
      formData.value.produce_plan_warehousing =
        res.data.produce_plan_warehousing;
         formData.value.entity_virtual_out =
        res.data.entity_virtual_out;
        formData.value.open_code_nested = res.data.open_code_nested;
        formData.value.enable_stand = res.data.enable_stand;
        formData.value.enable_invisible_code = res.data.enable_invisible_code;
        formData.value.open_multi_level_packaging = res.data.open_multi_level_packaging;
        formData.value.nested_rel_first = res.data.nested_rel_first;
        formData.value.nested_outside_code = res.data.nested_outside_code;
        formData.value.show_code_stand = Number(res.data.show_code_stand ?? 0);
        formData.value.code_stand_name = res.data.code_stand_name ?? "";
    };
    onMounted(() => {
      initData();
    });
    return {
      formData,
      save,
    };
  },
};
</script>
